var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIcondevicessquareeriaVmsAdurolightsolid = function SvgIcondevicessquareeriaVmsAdurolightsolid(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Devices/icon.devices.square.eria_vms_adurolight.solid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Devices/icon.devices.square.eria_vms_adurolight.solid",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "devices/devices.motion_sensor.front",
    transform: "translate(0.995, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Outer",
    stroke: "#666666",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 77,
    height: 77,
    rx: 10.7309237
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Outer",
    stroke: "#B8B8B8",
    strokeWidth: 0.670682731,
    fill: "#FFFFFF",
    x: 5.34031649,
    y: 5.33534137,
    width: 67.3293173,
    height: 67.3293173,
    rx: 10.7309237
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3947175,44.225325 C29.8519925,44.225325 30.2047475,43.87257 30.2047475,43.42836 L30.2047475,35.74614 C30.2047475,35.30193 29.8519925,34.949175 29.3947175,34.949175 C28.9505075,34.949175 28.5977525,35.30193 28.5977525,35.74614 L28.5977525,38.816415 L24.2340425,38.816415 L24.2340425,35.74614 C24.2340425,35.30193 23.8812875,34.949175 23.4370775,34.949175 C22.9798025,34.949175 22.6270475,35.30193 22.6270475,35.74614 L22.6270475,43.42836 C22.6270475,43.87257 22.9798025,44.225325 23.4370775,44.225325 C23.8812875,44.225325 24.2340425,43.87257 24.2340425,43.42836 L24.2340425,40.305825 L28.5977525,40.305825 L28.5977525,43.42836 C28.5977525,43.87257 28.9505075,44.225325 29.3947175,44.225325 Z M38.7492575,44.16 C39.1412075,44.16 39.4678325,43.84644 39.4678325,43.441425 C39.4678325,43.049475 39.1412075,42.72285 38.7492575,42.72285 L34.1634425,42.72285 L34.1634425,40.26663 L38.0960075,40.26663 C38.4879575,40.26663 38.8145825,39.95307 38.8145825,39.56112 C38.8145825,39.156105 38.4879575,38.82948 38.0960075,38.82948 L34.1634425,38.82948 L34.1634425,36.45165 L38.6839325,36.45165 C39.0758825,36.45165 39.4025075,36.13809 39.4025075,35.733075 C39.4025075,35.341125 39.0758825,35.0145 38.6839325,35.0145 L33.3664775,35.0145 C32.9092025,35.0145 32.5564475,35.367255 32.5564475,35.82453 L32.5564475,43.34997 C32.5564475,43.807245 32.9092025,44.16 33.3664775,44.16 L38.7492575,44.16 Z M47.0585975,44.16 C47.4636125,44.16 47.7902375,43.833375 47.7902375,43.42836 C47.7902375,43.023345 47.4636125,42.69672 47.0585975,42.69672 L42.9169925,42.69672 L42.9169925,35.74614 C42.9169925,35.30193 42.5642375,34.949175 42.1200275,34.949175 C41.6627525,34.949175 41.3099975,35.30193 41.3099975,35.74614 L41.3099975,43.34997 C41.3099975,43.807245 41.6627525,44.16 42.1200275,44.16 L47.0585975,44.16 Z M50.2072625,44.225325 C50.6514725,44.225325 51.0042275,43.87257 51.0042275,43.42836 L51.0042275,41.220375 L52.8202625,41.220375 C54.8322725,41.220375 56.4784625,40.149045 56.4784625,38.09784 L56.4784625,38.07171 C56.4784625,36.229545 55.1458325,35.0145 53.0031725,35.0145 L50.2072625,35.0145 C49.7499875,35.0145 49.3972325,35.367255 49.3972325,35.82453 L49.3972325,43.42836 C49.3972325,43.87257 49.7499875,44.225325 50.2072625,44.225325 Z M52.8725225,39.77016 L51.0042275,39.77016 L51.0042275,36.47778 L52.8725225,36.47778 C54.0745025,36.47778 54.8453375,37.039575 54.8453375,38.110905 L54.8453375,38.137035 C54.8453375,39.09078 54.0875675,39.77016 52.8725225,39.77016 Z",
    id: "HELP",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#666666",
    fill: "#FFFFFF",
    cx: 39.2,
    cy: 39.47,
    r: 8.21
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#B8B8B8",
    strokeWidth: 0.268273092,
    cx: 39.2,
    cy: 39.47,
    r: 15.9458635
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#666666",
    cx: 39.2,
    cy: 21.38,
    r: 1.34
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIcondevicessquareeriaVmsAdurolightsolid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.devices.square.eria_vms_adurolight.solid.12468482de2d95b315f956fed5cebf5c.svg";